/* istanbul ignore file */
import type { BrandRecommendationFragmentFragmentDoc } from '@packages/gql/generated/shopping/BrandRecommendationFragmentFragmentDoc';
import type { FragmentType } from '@packages/gql/generated/shopping/fragment-masking';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type { GTMEventGlycerinDisplayRecommendation } from '@packages/tracking/src/types/events';
import { useEffect } from 'react';
import { getBrandGlycerinTiles } from '../../helpers/getBrandGlycerinTiles';
import type { RdeType } from '../../types';

type TrackingProps = {
  rdeTypeAbbr?: string;
  rdeType: RdeType;
  recommendations?: Array<FragmentType<typeof BrandRecommendationFragmentFragmentDoc>>;
  trackingCondition: boolean;
  title: string;
};

export const useBrandsRecoTracking = ({
  rdeTypeAbbr,
  trackingCondition,
  rdeType,
  recommendations,
  title,
}: TrackingProps) => {
  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    if (trackingCondition && rdeTypeAbbr && recommendations !== undefined) {
      // glycerin seen tracking
      dispatchGTMEvent<GTMEventGlycerinDisplayRecommendation>({
        event: 'DisplayRecommendation',
        DisplayRecommendationData: {
          name: title,
          // TODO: add placement as prop in trackingProps -> https://empiriecom.atlassian.net/browse/INFORM-2616
          // placement: GlycerinPlacement.CONTENT,
          recoId: rdeTypeAbbr,
          recoType: 'carousel',
          strategy: rdeType,
          tiles: getBrandGlycerinTiles(recommendations),
          totalSize: recommendations.length,
        },
      });
    }
  }, [trackingCondition, dispatchGTMEvent, rdeTypeAbbr, rdeType, recommendations, title]);
};
